import { OrderStatus } from '@onrunning/backstage-models';

export const ValidOrderEditStatusesForDealer = [
  OrderStatus.InProgress,
  OrderStatus.ConfirmedInDynamics,
  OrderStatus.Open,
  OrderStatus.Backorder,
  OrderStatus.ReadyToSubmit,
  OrderStatus.InSubmission,
  OrderStatus.Submitted,
] as OrderStatus[];

export const ValidOrderEditStatusesForSalesRep = [
  OrderStatus.Backorder,
  OrderStatus.Open,
  OrderStatus.Hold,
] as OrderStatus[];
